import React, { useEffect, useState } from 'react'
import { InvoiceMultiPageSetting } from '../../../interfaces/Invoices'
import { InvoiceAttachments } from '../../../components/Pipelines/Logs/InvoiceAttachments'
import useSWR from 'swr'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { getInvoiceGeneratedByLatest } from '../../../api/InvoicesCRUD'
import { useIntl } from 'react-intl'
import { decrypt, encrypt } from '../../../functions/encryption'

const API_URL = process.env.REACT_APP_API_URL
const KEY_ENCRYPT = process.env.REACT_APP_KEY_ENCRYPT

const WebViewPreviewInvoice = () => {
    const intl = useIntl()
    const [selectInvoice, setSelectInvoice] = useState<InvoiceMultiPageSetting | null>(null)
    const [tokenDecrypt, setTokenDecrypt] = useState<string | null>(null)
    // web-view-invoice/:token/:progressId/:leadId -> 34a90996-05d9-4102-bead-5c38e8b55faf/6fda6b83-8837-4eb4-82d9-de6825dd836f/
    /*
    leadId : "d281e403-050b-4077-93b4-c7f7497da9da"
    progressId : "6fda6b83-8837-4eb4-82d9-de6825dd836f"
    token : "20144f52-cfed-4b76-bf6e-b3691d78dc7d"
    http://localhost:3011/web-view-invoice/fl9eTVUKf1NUAldXV2FbDU5XQSgHTwQcUAB6Vl4dVlQuAk4F/6fda6b83-8837-4eb4-82d9-de6825dd836f/d281e403-050b-4077-93b4-c7f7497da9da
    http://localhost:3011/web-view-invoice/fldfHVUIeVFUVlJXAmFbV00HQShUSFQcUQB8XQ4bUAkpWR9Z/8523bef4-33ee-4ab6-ba7b-e791244c208c/14b2ddfd-9d9b-4339-bfae-39bdab42a1e6
    */
    const { token, progressId, leadId } = useParams()

    useEffect(() => {
        if (token) {
            const decrypted = decrypt(token, KEY_ENCRYPT!)
            setTokenDecrypt(decrypted)
        }
    }, [token])

    const fetcher = async (url: string) => {
        try {
            const res = await axios.get(url, {
                headers: {
                    'X-Auth-Token': tokenDecrypt,
                }
            })
            return res.data
        } catch (error) {
            console.log(error, 'error')
        }
    }

    const { data: lead, isLoading: isLoadingLead } = useSWR(tokenDecrypt ? `${API_URL}v2/lead/${leadId}` : null, fetcher)

    const getInvoiceGenerated = async () => {
        try {
            if (tokenDecrypt && progressId && leadId) {
                const response = await getInvoiceGeneratedByLatest(tokenDecrypt, progressId, leadId)
                if (response.data.data) {
                    setSelectInvoice(response.data.data)
                }
            }
        } catch (error) {
            console.log(error, 'error')
            setSelectInvoice(null)
        }
    }

    useEffect(() => {
        if (!isLoadingLead && tokenDecrypt) {
            getInvoiceGenerated()
        }

    }, [isLoadingLead])

    const handleModalClose = (isSkipAlert: boolean = false) => {
        return void 0
    }

    if (!isLoadingLead && !selectInvoice) {
        return <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
            <div className='d-flex flex-column gap-2'>
                <h4 className='text-center'>{intl.formatMessage({ id: 'INVOICE.PANEL.NO_INVOICE_FOUND' })}</h4>
            </div>
        </div>
    }

    return (
        <>
            {
                selectInvoice && tokenDecrypt && (
                    <InvoiceAttachments
                        lead={lead}
                        invoice={selectInvoice}
                        context={'send-whatsapp'}
                        routerContext="add-log"
                        typeInvoiceAttachments='web-view-preview'
                        tokenWebView={tokenDecrypt}
                        handleInvoiceModalClose={handleModalClose}
                    />
                )}
        </>
    )
}

export default WebViewPreviewInvoice

